import { defineAsyncComponent } from 'vue';

export default {
	description: "Позиции обработанных накладных",
	access: {
		read: true,
		create: true,
		update: true,
		delete: ['admin', 'warehouse', 'medregistrator', 'medical_doctor']
	},
	forms: {
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue')),
			config: {
				fields: {
					position_number: {
						config: {
							width: '80px'
						}
					},
					// product_code: {
					// 	config: {
					// 		width: '120px',
					// 		visible: false
					// 	}
					// },
					product_name: {
						config: {
							width: '300px'
						}
					},
					medicament_id: {
						description: 'Лекарственное средство',
						config: {
							width: '280px',
							reference: 'medicaments',
							displayField: 'name',
							visible: false
						}
					},
					manufacturer_id: {
						description: 'Производитель',
						config: {
							width: '80px',
							render: (_value: any, row: any) =>
								row._manufacturer_id || row.manufacturer || row.manufacturer_id || ''
						}
					},
					production_country_id: {
						description: 'Страна',
						config: {
							width: '120px',
							render: (_value: any, row: any) =>
								row._production_country_id || row.country || row.production_country_id || ''
						}
					},
					series: {
						config: {
							width: '100px'
						}
					},
					expiry_date: {
						config: {
							width: '120px'
						}
					},
					certificate: {
						config: {
							width: '150px'
						}
					},
					group: {
						description: 'Группа товара',
						config: {
							width: '200px',
							reference: 'product_groups',
							displayField: 'name',
							render: (_value: any, row: any) =>
								row.group_name || row._group || row.group || ''
						}
					},
					funding_source_id: {
						description: 'Источник финансирования',
						config: {
							width: '250px',
							render: (_value: any, row: any) =>
								row.funding_source_name || row._funding_source_id || row.funding_source_id || ''
						}
					},
					unit: {
						config: {
							width: '100px'
						}
					},
				quantity: {
					config: {
						width: '100px',
						render: (value: any) => { const n = parseFloat(value); return (!n || isNaN(n)) ? '' : n.toFixed(3).replace(/\.?0+$/, ''); }
					}
				},
				price: {
					config: {
						width: '120px',
						render: (value: any) => { const n = parseFloat(value); return (!n || isNaN(n)) ? '' : n.toFixed(2).replace(/\.?0+$/, ''); }
					}
				},
				cost: {
					config: {
						width: '120px',
						render: (value: any) => { const n = parseFloat(value); return (!n || isNaN(n)) ? '' : n.toFixed(2).replace(/\.?0+$/, ''); }
					}
				},
				vat_rate: {
					config: {
						width: '100px',
						render: (value: any) => { const n = parseFloat(value); return (!n || isNaN(n)) ? '' : n.toFixed(2).replace(/\.?0+$/, ''); }
					}
				},
				vat_amount: {
					config: {
						width: '120px',
						render: (value: any) => { const n = parseFloat(value); return (!n || isNaN(n)) ? '' : n.toFixed(2).replace(/\.?0+$/, ''); }
					}
				},
				cost_with_vat: {
					config: {
						width: '150px',
						render: (value: any) => { const n = parseFloat(value); return (!n || isNaN(n)) ? '' : n.toFixed(2).replace(/\.?0+$/, ''); }
					}
				}
				}
			}
		},
		edit: {
			panel: {
				width: '80%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		}
	}
}
